import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import MultiCarousel from './Carousels/MultipleCarousel';

const Q = graphql`
  {
    cases: allMarkdownRemark(
      filter: {
        frontmatter: {
          templateKey: { eq: "case-study" }
          published: { ne: false }
        }
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            images {
              logo {
                childImageSharp {
                  fixed(
                    duotone: {
                      highlight: "#cccccc"
                      shadow: "#505050"
                      opacity: 0
                    }
                    width: 140
                    quality: 100
                  ) {
                    ...GatsbyImageSharpFixed_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const ResultsLogoSwiper = ({ slidesToShow, responsive }) => {
  const data = useStaticQuery(Q);
  const cases = data.cases.edges.map(({ node }) => node);
  return (
    <MultiCarousel slidesToShow={slidesToShow} responsive={responsive}>
      {cases.map(caseStudy => {
        return (
          <div key={caseStudy.id}>
            <Img
              fixed={caseStudy.frontmatter.images.logo.childImageSharp.fixed}
              alt="Our clients logo"
              title="clients logo"
            />
          </div>
        );
      })}
    </MultiCarousel>
  );
};

export default ResultsLogoSwiper;
